// Import component scripts (auto-generated)
import './components.js';

// Import layout scripts (auto-generated)
import './layouts.js';

// Import theme scripts
import './core.js';
import './faq.js';
import './footer.js';
import './lazy-load-images.js';
import './reveal.js';
import './animations.js';
import './file-upload.js';
import './share.js';
